import React, {FC} from 'react';
import styled, {css} from 'styled-components';

/*
 * Props.
 */

interface AvatarBackgroundProps {
  className?: string;
  color: string;
  isFaded?: boolean;
}

/*
 * Style.
 */

interface AvatarBackgroundStyleProps {
  $color: string;
  $isFaded?: boolean;
}
const BackgroundDiv = styled.div<AvatarBackgroundStyleProps>`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;

  background-color: ${(p) => p.$color};
  ${(p) => p.$isFaded && addFadedStyle};
`;

function addFadedStyle() {
  return css`
    filter: saturate(0);
    opacity: 0.6;
  `;
}

/*
 * Component.
 */

export const AvatarBackground: FC<AvatarBackgroundProps> = (props) => (
  <BackgroundDiv $color={props.color} $isFaded={props.isFaded} className={props.className} />
);
